<template>
  <div
    class="playposit-text-box py-1"
    :class="{
      'no-indent': !indent,
      'mt-1': addExtraSpaceAbove,
    }"
    :style="{
      backgroundColor: colorScheme.light
    }"
  >
    <div
      class="icon-rod-wrapper"
      :style="{
        justifyContent: iconPosition === 'middle' ? 'center' : 'flex-start'
      }"
    >
      <div
        v-if="icon && iconPosition === 'middle' && showColorRod"
        class="color-rod"
        :style="{
          backgroundColor: colorScheme.dark
        }"
      ></div>
      <v-icon
        v-if="icon"
        :color="colorScheme.dark"
        :size="22"
      >
        {{icon}}
      </v-icon>
      <div
        v-if="showColorRod"
        class="color-rod"
        :style="{
          backgroundColor: colorScheme.dark
        }"
      ></div>
    </div>
    <div class="pl-2">
      <div
        v-if="(
          subtitle.length
          && subtitleChips.length
        )"
      >
        <span v-html="subtitle"></span>
        <v-chip
          v-for="(subtitle, index) in subtitleChips"
          :key="`${subtitle}-${index}`"
        >
          {{ subtitle }}
        </v-chip>
      </div>
      <div
        v-else-if="subtitle.length"
        :class="subtitleClasses"
        v-html="subtitle">
      </div>
      <div
        v-if="showTitle"
        v-html="title"
        class="text-box-title uppercase body-2"
        :class="titleClasses"
        :style="{
          color: colorScheme.dark
        }">
      </div>
      <div
        v-if="showText"
        class="text-box-content pp-interaction-feedback"
        :class="textClasses"
        v-html="text">
      </div>
      <InteractionAttachments
        v-show="showAttachments"
        :attachments="attachments"
      />
    </div>
  </div>
</template>

<script>
import InteractionAttachments from './InteractionAttachments.vue';

export default {
  name: 'text-box',
  components: {
    InteractionAttachments,
  },
  props: {
    colorKey: {
      type: String,
      validate: (colorKey) => [
        'gray',
        'grey',
        'feedback',
        'green',
        'success',
        'correct',
        'red',
        'error',
        'incorrect',
        'yellow',
        'missed',
        'hidden',
      ].includes(colorKey),
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleChips: {
      type: Array,
      default: () => ([]),
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: null,
    },
    iconPosition: {
      type: String,
      default: 'top',
      validate: (iconPosition) => ['top', 'middle'].includes(iconPosition),
    },
    showText: {
      type: [Number, Boolean],
      default: true,
    },
    showColorRod: {
      type: [Number, Boolean],
      default: true,
    },
    showTitle: {
      type: [Number, Boolean],
      default: true,
    },
    showAttachments: {
      type: [Number, Boolean],
      default: true,
    },
    indent: {
      type: [Number, Boolean],
      default: true,
    },
    titleClasses: {
      type: String,
      default: '',
    },
    subtitleClasses: {
      type: String,
      default: 'mb-3 subheading',
    },
    textClasses: {
      type: String,
      default: '',
    },
    attachments: {
      type: Array,
      default: () => ([]),
    },
    addExtraSpaceAbove: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorScheme() {
      const ck = this.colorKey.toLowerCase();
      if (['grey', 'gray', 'feedback'].includes(ck)) {
        return {
          light: '#EEEEEE',
          dark: '#9E9E9E',
        };
      } else if (['neutral', 'ungraded'].includes(ck)) {
        return {
          light: '#E3F2FD',
          dark: '#2196F3',
        };
      } else if (['green', 'success', 'correct'].includes(ck)) {
        return {
          light: '#E8F5E9',
          dark: '#4CAF50',
        };
      } else if (['red', 'error', 'incorrect'].includes(ck)) {
        return {
          light: '#FFEBEE',
          dark: '#F44336',
        };
      } else if (['yellow', 'missed'].includes(ck)) {
        return {
          light: '#FFFDE7',
          dark: '#FFC107',
        };
      } else if (['hidden'].includes(ck)) {
        return {
          light: 'transparent',
          dark: 'rgba(0, 0, 0, 0.87)',
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss">
  .playposit-text-box {
    display: flex;

    .icon-rod-wrapper {
      width: 24px;
      min-width: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .color-rod {
        flex: 1;
        width: 6px;
      }
    }

    .pl-2 {
      /* Allow the feedback text box content to fill some width of the ancestor container element it is in. */
      width: 80%;
    }

    .text-box-content {
      color: rgba(0,0,0,0.54);
    }
  }
</style>